"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Result = void 0;
var Result;
(function (Result) {
    Result["SUCCESS"] = "SUCCESS";
    Result["FAILURE"] = "FAILURE";
    /**
     * The service accepted the request but did not complete the operation synchronously.
     */
    Result["ACCEPTED"] = "ACCEPTED";
})(Result || (exports.Result = Result = {}));
//# sourceMappingURL=WarehouseUpdateStatusResponse.js.map